import React, { useEffect } from 'react';
import { X, AlertCircle, CheckCircle } from 'lucide-react';

const TOAST_CONFIG = {
  error: {
    bg: 'bg-red-600',
    icon: <AlertCircle size={16} />,
  },
  success: {
    bg: 'bg-emerald-600',
    icon: <CheckCircle size={16} />,
  },
  warning: {
    bg: 'bg-amber-500',
    icon: <AlertCircle size={16} />,
  },
};

export default function Toast({
  message,
  type = 'error',
  onClose,
  duration = 4500,
}) {
  useEffect(() => {
    if (!message) return;

    const timer = setTimeout(() => {
      onClose?.();
    }, duration);

    return () => clearTimeout(timer);
  }, [message, duration, onClose]);

  if (!message) return null;

  const config = TOAST_CONFIG[type] || TOAST_CONFIG.error;

  return (
    <div
      className={`fixed top-4 right-4 z-[9999]
        flex items-center gap-3
        px-4 py-3
        rounded-lg
        shadow-2xl
        text-white
        text-sm
        font-medium
        max-w-xs
        ${config.bg}`}
    >
      {config.icon}

      <span className="flex-1">
        {message}
      </span>

      <button
        type="button"
        onClick={onClose}
        className="opacity-70 hover:opacity-100 ml-1"
        aria-label="Close notification"
      >
        <X size={14} />
      </button>
    </div>
  );
}
